'use strict';

let CustomError=require('pulsar-utils/dist-es6/customError');let

AppReloadRequiredError=class AppReloadRequiredError extends CustomError{
constructor(){
super('AppReloadRequiredError');
}};


module.exports=AppReloadRequiredError;
//# sourceMappingURL=appReloadRequiredError.js.map
